import {createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig, HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'libs/api/api';

import {AddCartItemUpsellType} from './addCartItemUpsellType';

export const initialState: AddCartItemUpsellType = {
    messages: [{message: '', type: ''}],
    status: 'initial',
};

/**
 * Add upsell to cart
 * @param {string} itemId cart item Id
 * @param {string} productId product id to add
 * @returns {ActionType<AxiosPromise>} Action
 */
export const addUpsellFrameToCart = createAsyncThunk<
    {data: AddCartItemUpsellType},
    {itemId: string; productId: string},
    {rejectValue: {response: {data: AddCartItemUpsellType}}}
>('CART@ADD_UPSELL_FRAME', async ({itemId, productId}, {rejectWithValue}) => {
    try {
        return await apiConfig.instanceGusaBackend({
            headers: {
                [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                    HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.APPLICATION_JSON,
            },
            method: 'post',
            params: {
                itemId,
                productId,
            },
            url: ENDPOINTS.UPSELL_ADD_FRAME,
        });
    } catch (e) {
        return rejectWithValue(e);
    }
});

/**
 * Add item upsell frame
 *
 * @param {object} state - Current state
 * @param {object} action - Received action
 * @returns {object} Item removal data
 */
export const addCartItemUpsell = createReducer(initialState, builder =>
    builder
        .addCase(addUpsellFrameToCart.fulfilled, (_, action) => ({
            messages: action?.payload?.data?.messages,
            status: 'fulfilled',
        }))
        .addCase(addUpsellFrameToCart.pending, state => ({...state, status: 'pending'}))
        .addCase(addUpsellFrameToCart.rejected, (state, action) => ({
            ...state,
            ...action?.payload?.response?.data,
            status: 'rejected',
        })),
);
